import type { ComponentProps } from "react";
import { Link, type LinkProps } from "@tanstack/react-router";

import { focusRing, Heading } from "@/ui";

type ImageLinkProps = Required<
  Pick<ComponentProps<"img">, "src" | "title"> & Pick<LinkProps, "to">
>;

export const ImageLink = ({ src, title, to }: ImageLinkProps) => {
  return (
    <Link
      className={`group flex flex-col items-center gap-4 rounded-card p-4 transition-colors hover:bg-surface-hover sm:p-6 ${focusRing}`}
      to={to}
    >
      <img
        alt={title}
        className="aspect-square size-36 rounded-full bg-surface-muted object-cover transition-transform duration-200 group-hover:scale-[1.03] sm:h-56 sm:w-56"
        src={src}
      />
      <Heading className="text-lg transition-colors group-hover:text-accent sm:text-xl" level={3}>
        {title}
      </Heading>
    </Link>
  );
};
